import StarscapeCallToActionBreakoutModule from './StarscapeCallToActionBreakoutModule'

export default StarscapeCallToActionBreakoutModule
